var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.item.multiple
        ? _c(
            "el-radio-group",
            {
              directives: [
                { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
              ],
              on: { change: _vm.handleChange },
              model: {
                value: _vm.changeValue,
                callback: function ($$v) {
                  _vm.changeValue = $$v
                },
                expression: "changeValue",
              },
            },
            _vm._l(_vm.getOptions(), function (option) {
              return _c(
                "div",
                { key: option.value, staticClass: "img-radio-item" },
                [
                  _vm.item.config.showVoteResult
                    ? _c("vote", {
                        attrs: {
                          value: option.value,
                          type: "img",
                          "vote-list": _vm.voteList,
                          "total-vote": _vm.totalVote,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "el-image",
                    {
                      staticClass: "image",
                      attrs: {
                        "preview-src-list": [option.image],
                        src: option.image,
                        fit: "scale-down",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [_c("i", { staticClass: "el-icon-picture-outline" })]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "checkbox-slot" },
                    [
                      _c("el-radio", { attrs: { label: option.value } }, [
                        _c("div", [_vm._v(" " + _vm._s(option.label) + " ")]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _c(
            "el-checkbox-group",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.changeValue,
                callback: function ($$v) {
                  _vm.changeValue = $$v
                },
                expression: "changeValue",
              },
            },
            _vm._l(_vm.getOptions(), function (option) {
              return _c(
                "div",
                { key: option.value, staticClass: "img-radio-item" },
                [
                  _vm.item.config.showVoteResult
                    ? _c("vote", {
                        attrs: {
                          value: option.value,
                          type: "img",
                          "vote-list": _vm.voteList,
                          "total-vote": _vm.totalVote,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "el-image",
                    {
                      staticClass: "image",
                      attrs: {
                        "preview-src-list": [option.image],
                        src: option.image,
                        fit: "cover",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [_c("i", { staticClass: "el-icon-picture-outline" })]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "checkbox-slot" },
                    [
                      _c("el-checkbox", { attrs: { label: option.value } }, [
                        _c("div", [_vm._v(" " + _vm._s(option.label) + " ")]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }